import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import router from "@/router";
import store from "@/store";
import "@/styles/index.css";
import axios from "axios";
import { setBaseUrl } from "@/config";

Vue.use(ElementUI);

// 注册全局组件
import Record from "@/components/Record/Record";
import SongList from "@/components/SongList/SongList";
import APlayer from "@moefe/vue-aplayer";
Vue.use(APlayer, {
  defaultCover: '',
  productionTip: true,
});
Vue.component(SongList.name, SongList);
Vue.component(Record.name, Record);

// 引入相关API请求接口
import API from "@/api";

Vue.config.productionTip = false;

// 获取域名的接口地址
const domainUrl = window.location.protocol + '//' + window.location.hostname + '/get-domain'

// 先获取 BASE_URL，再创建 Vue 实例
axios.get(domainUrl).then(res => {
  if (res.data && res.data.apiDomain) {
    setBaseUrl(res.data.apiDomain)
  }
  
  new Vue({
    render: (h) => h(App),
    router,
    store,
    beforeCreate() {
      Vue.prototype.$bus = this;
      Vue.prototype.$API = API;
    },
  }).$mount("#app");
}).catch(err => {
  console.error('获取 BASE_URL 失败:', err)
  // 即使失败也继续创建 Vue 实例
  new Vue({
    render: (h) => h(App),
    router,
    store,
    beforeCreate() {
      Vue.prototype.$bus = this;
      Vue.prototype.$API = API;
    },
  }).$mount("#app");
})
